import React, { useMemo } from 'react';

import { Stack, Typography } from '@gogame/components';
import { useDateFormat } from '@gogame/intl-ts';

import Empty from 'scenes/Gallery/components/Empty';

import { AttributeItem } from '../AttributeList';

export const ExpirationDate = ({ value, typographyVariant = 'body1' }) => {
  const format = useDateFormat({ template: 'LL' });

  const displayValue = useMemo(() => {
    if (!value) {
      return;
    }

    const formattedValue = format(value);
    return formattedValue === format(new Date().toISOString())
      ? 'Today'
      : formattedValue;
  }, [value]);

  if (!value) {
    return <Empty />;
  }

  return (
    <Stack spacing={0.5} direction={'row'} alignItems={'center'}>
      <AttributeItem
        type={'icon'}
        value={value}
        valueParser={'expirationDate'}
      />
      <Typography variant={typographyVariant} noWrap={true}>
        {displayValue}
      </Typography>
    </Stack>
  );
};
export default ExpirationDate;
